import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { CommentForm, CommentList, CommentReportModal, CommentRow, CommentsTypeEnum, useComments } from 'features/comments';
import { Flex, Loading, Pace, Typography } from 'components';
import { FilterButton } from './styles';

const Comments = () => {
  const [loading, setLoading] = useState(true);

  const { productSlug, productClassUuid, contentUuid } = useParams();

  const {
    comments,
    fetchComments,
    fetchedComments,
    commentTypeFilter,
    setCommentTypeFilter,
    reportingCommentUuid,
    commentsConfig,
    fetchCommentsConfig,
  } = useComments();

  const fetchConfig = useCallback(() => {
    fetchCommentsConfig();
  }, [productSlug, productClassUuid, contentUuid]);

  useEffect(() => {
    if (commentsConfig?.enableComments === null) fetchConfig();
  }, [productSlug, productClassUuid, contentUuid, commentsConfig]);

  useEffect(() => {
    fetchComments(() => {
      setLoading(false);
    });
  }, [productSlug, productClassUuid, contentUuid, commentTypeFilter]);

  let label = 'Nenhum comentário';
  if (comments?.length) {
    label = `${comments?.length} comentário${comments?.length === 1 ? '' : 's'}`;
  }

  return commentsConfig?.enableComments ? (
    <>
      {!!reportingCommentUuid && <CommentReportModal />}

      <Flex position="relative" bg="commentsBg" py={6} pl={{ m: 4, d: 6 }} pr={{ m: 4, d: 10 }} flexDirection="column">
        {!fetchedComments ? (
          <Loading fixed={false} />
        ) : (
          <>
            {loading && <Pace style={{ top: 0, right: 0 }} />}

            <CommentRow first>
              <Flex flexDirection={{ m: 'column', t: 'row' }} flexGrow={1} alignItems="flex-start" justifyContent="space-between" pb={4}>
                <Typography color="color100">{label}</Typography>

                <Flex flexGrow={0} mt={{ m: 2, t: 0 }}>
                  <FilterButton
                    onClick={() => setCommentTypeFilter(CommentsTypeEnum.Doubt)}
                    data-active={commentTypeFilter === CommentsTypeEnum.Doubt}
                  >
                    Dúvidas
                  </FilterButton>

                  <FilterButton
                    onClick={() => setCommentTypeFilter(CommentsTypeEnum.Comment)}
                    data-active={commentTypeFilter === CommentsTypeEnum.Comment}
                  >
                    Comentários
                  </FilterButton>

                  <FilterButton onClick={() => setCommentTypeFilter(null)} data-active={commentTypeFilter === null}>
                    Mais recentes
                  </FilterButton>
                </Flex>
              </Flex>
            </CommentRow>

            <CommentRow>
              <CommentForm collapsed={false} />
            </CommentRow>

            <CommentList comments={comments} />
          </>
        )}
      </Flex>
    </>
  ) : (
    <></>
  );
};

export default Comments;
